export default __webpack_public_path__ + "media/flavours/glitch/images/logo_warn_glitch-68f2721071b15e54520ac713d29675cf.svg";